var WDN = WDN || {};

if (typeof WDN.CartPage === "undefined") {
  WDN.CartPage = (function () {
    var refresh;

    refresh = function () {
      WDN.CartCount.update();

      new WDN.SectionRenderer({
        selectors: {
          output: "[data-cart-layout]",
        },
        autoInit: true,
        replaceOutput: true,
        sections: ["async-cart-layout"],
      });
    };

    return {
      refresh,
    };
  })();
}
